
  import { defineComponent, inject } from "vue";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import { getValueByPath } from "@/helpers/utils";
  import { get } from "lodash";
  import { ApplicationState } from "@/stores/ApplicationStore";
  import { ContextKeys } from "@/enums/contextKeys.enum";

  export default defineComponent({
    name: "HeadingV2",

    extends: BaseProcessComponentV2,

    setup(props: any) {
      const root: string = props.path.split(".")[0];
      return { [root]: inject(root) };
    },

    computed: {
      headingTag(): string {
        const level = Number(get(this, "settings.attributes.level", 2));

        return level >= 1 && level <= 6 ? `h${level}` : "h2";
      },

      title(): string {
        const title = get(this, "settings.attributes.title", null) as string | null;

        if (title) {
          return title;
        }

        return (
          getValueByPath(
            {
              [ContextKeys.APPLICATION]: (this.applicationStore as ApplicationState).application,
              [ContextKeys.FORM]: get(this, this.root, {}),
            },
            get(this, "settings.attributes.source", "") as any
          ) ?? ""
        );
      },
    },
  });
